import React from 'react'
import PropTypes from 'prop-types'
import parseGGDriver from '../../../helpers/parseGGDriver'

class DesignFrontCol extends React.PureComponent {

    render() {
        const {designFront, productStatus} = this.props
        const _designFront = parseGGDriver(designFront || '')
        const displayField = productStatus !== 'cancelled' ? 'notDisableCancel DesignFront' : 'DesignFront'

        return (
            <div className={displayField}>
                {_designFront &&
                <a href={_designFront} target='_blank' rel='noopener noreferrer'><u>F</u>ront<br/>Mặt TRƯỚC</a>}
            </div>
        )
    }
}

DesignFrontCol.propTypes = {
    productStatus:PropTypes.string,
    designFront: PropTypes.string,
}

export default DesignFrontCol
